import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const individualSupportConfig: Record<string, FormConfigProps> = {
  prepareSupportMaterials: {
    label: 'mokoma / padedama pasirengti struktūruotą atraminę medžiagą',
    value: 'prepareSupportMaterials',
  },
  fillOutGraphicOrganizers: {
    label: 'mokoma pildyti / naudotis grafinėmis tvarkyklėmis',
    value: 'fillOutGraphicOrganizers',
  },
  useAuxiliaryTools: {
    label: 'mokoma / skatinama naudotis specialiosiomis mokymo priemonėmis',
    value: 'useAuxiliaryTools',
  },
  useSupportMaterials: {
    label: 'mokoma / skatinama naudotis atramine medžiaga',
    value: 'useSupportMaterials',
  },
  readAloud: {
    label: 'tekstai ir (ar) užduotys perskaitomi:',
    value: 'readAloud',
    children: {
      readAloudAllways: {
        label: 'visada',
        value: 'readAloudAllways',
        paddingLeft: 24,
      },
      readAloudAssNeeded: {
        label: 'pagal poreikį',
        value: 'readAloudAssNeeded',
        paddingLeft: 24,
      },
    },
  },
  useAssistiveToolsForListeningTasks: {
    label:
      'tekstai ir (ar) užduotys klausomos naudojantis specialiosiomis mokymo priemonėmis:',
    value: 'useAssistiveToolsForListeningTasks',
    children: {
      useAssistiveToolsForListeningTasksAllways: {
        label: 'visada',
        value: 'useAssistiveToolsForListeningTasksAllways',
        paddingLeft: 24,
      },
      useAssistiveToolsForListeningTasksAsNeeded: {
        label: 'pagal poreikį',
        value: 'useAssistiveToolsForListeningTasksAsNeeded',
        paddingLeft: 24,
      },
    },
  },
  ensureInstructionsUnderstood: {
    label:
      'įsitikinama ar mokinys gerai suprato žodines instrukcijas, bendresnius žodžius, sąvokas',
    value: 'ensureInstructionsUnderstood',
  },
  ensureTaskUnderstood: {
    label: 'įsitikinama, kad mokinys suprato užduotį',
    value: 'ensureTaskUnderstood',
  },
  explainTaskConditions: {
    label: 'žodžiu / vaizdu paaiškinamos užduotys, tekstinių uždavinių sąlygos',
    value: 'explainTaskConditions',
  },
  encouragedToAskQuestionsIfUnclear: {
    label:
      'mokoma ir skatinama klausti, nesupratus užduoties atlikimo nurodymų, paaiškinimų, instrukcijų',
    value: 'encouragedToAskQuestionsIfUnclear',
  },
  assistStartingTask: {
    label:
      'teikiama pagalba, atliekant užduotį, aptariama tolesnė jos atlikimo eiga',
    value: 'assistStartingTask',
  },
  completeTaskWithExample: {
    label: 'remiantis pavyzdžiu kartu su mokiniu atliekama bent viena užduotis',
    value: 'completeTaskWithExample',
  },
  analyzeCommonMistakes: {
    label: 'kartu su mokiniu analizuojamos dažniausiai pasitaikančios klaidos',
    value: 'analyzeCommonMistakes',
  },
  individualSupportOther: {
    label: 'kita:',
    value: 'individualSupportOther',
    isInput: true,
  },
};

export const Block33 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 5 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Teikiama individuali pagalba:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={individualSupportConfig}
          formPathParams={['subject', 'block3', 'individualSupport']}
          form={form}
        />
      </div>
    );
  },
);
